/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
import { getSortedProductConfigurations } from 'pricing-pages-lib/utils/productConfigUtils';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { productDataSelector } from '../selectors/SelectorUtils';
export const useSortedProductConfigurations = (initialProductConfigurations = []) => {
  const productData = useSelector(productDataSelector);
  const [productConfigurations, setProductConfigurations] = useState(getSortedProductConfigurations({
    productData
  }, {
    productConfigurations: initialProductConfigurations
  }));
  const sortedSetProductConfigurations = useCallback(arg => {
    if (typeof arg === 'function') {
      // More context on why we need a setTimeout here https://git.hubteam.com/HubSpot/pricing-pages-unified-ui/pull/4990
      setTimeout(() => setProductConfigurations(prevConfigurations => getSortedProductConfigurations({
        productData
      }, {
        productConfigurations: arg(prevConfigurations)
      })), 0);
    } else {
      setTimeout(() => setProductConfigurations(getSortedProductConfigurations({
        productData
      }, {
        productConfigurations: arg
      })), 0);
    }
  }, [productConfigurations, setProductConfigurations, productData]);
  return [productConfigurations, sortedSetProductConfigurations];
};